import React from 'react';
import {AvForm} from 'availity-reactstrap-validation';
import Loading from "../../shared/component/others/Loading";
import AdminSaleReportColumn from "../../shared/component/dataTable/columns/AdminSaleReportColumn.json";
import Dialog from "../../shared/component/dialog/Dialog";
import GeneralUtils from "../../shared/utils/GeneralUtils";
import AdminZXReportService from "../../shared/service/AdminZXReportService";
import DataTable from "../../shared/component/dataTable/DataTable";
import AdminSaleReportDetail from "./AdminSaleReportDetail";
import MerchantBranchService from "../../shared/service/MerchantBranchService";
import {Button, Col, Row} from "reactstrap";
import Translate from "../../shared/language/Translate";
import AvField from "../../shared/component/form/AvField";
import DateInput from "../../shared/component/form/DateInput";
import MerchantBranchCredentialsService from "../../shared/service/MerchantBranchCredentialsService";
import {Chart} from 'primereact/chart';
import {InputText} from "primereact/inputtext";
import MerchantBranchFilter from "../merchant/MerchantBranchFilter";
import {DAYS_FILTER} from "../../shared/utils/Constants";
import '../reports/SaleReportPage.css';
import '../../shared/styles/SettingsPage.css';


const defaultSummary = {
    netSale: 0,
    grossSale: 0,
    refunds: 0,
    netSaleCnt: 0,
    grossSaleCnt: 0,
    refundsCnt: 0
};

export default class AdminSaleReport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            saleReportList: [],
            clientList: [],
            loading: false,
            displayCalculateConfirmDialog: false,
            noticeResponse: "",
            reportId: null,
            daysFilter: "Last 7 Days",
            startDate: GeneralUtils.getLast7DaysRange()[0].getTime(),
            endDate: GeneralUtils.getLast7DaysRange()[1].getTime(),
            summary: Object.assign(defaultSummary),

        };
        this.adminZXReportService = new AdminZXReportService();
        this.merchantBranchService = new MerchantBranchService();
        this.merchantBranchCredentialsService = new MerchantBranchCredentialsService();

    }

    componentDidMount() {
        this.merchantBranchService.findAll().then(response => this.setState({
            merchantBranchList: response
        }));
        this.merchantBranchCredentialsService.getClientTills(-1).then(response => this.setState({
            clientList: response
        }));

        this.refreshSummary();

    }


    renderPageHeader() {
        return (
            <div className="sale-report-page__header">
                <h1 className="sale-report-page__title">Sale Report</h1>
            </div>
        );
    }

    render() {
        return (
            <div className="sale-report-page sale-report-page--full col-md-12">
                <AvForm>
                    <div className="sale-report-page__shell">
                        {this.renderPageHeader()}
                        <div className="sale-report-page__panel">
                            {this.renderFilter()}
                            {this.renderSummaryGraphics()}
                            {this.renderReports()}
                        </div>
                    </div>
                </AvForm>
                {this.state.loading && <Loading/>}
            </div>
        );
    }

    renderSummaryGraphics() {

        const chartSalesData = {
            labels: ['Net ' + GeneralUtils.formatGBP(this.state.summary.netSale), 'Gross ' + GeneralUtils.formatGBP(this.state.summary.grossSale), 'Refund ' + GeneralUtils.formatGBP(this.state.summary.refunds)],
            datasets: [
                {
                    label: 'Sales Amount (£)',
                    backgroundColor: ['#42A5F5', '#66BB6A', '#FFA726'],
                    data: [this.state.summary.netSale, this.state.summary.grossSale, this.state.summary.refunds],
                }
            ]
        };

        const chartSalesCountData = {
            labels: ['Net ' + this.state.summary.netSaleCnt, 'Gross ' + this.state.summary.grossSaleCnt, 'Refund ' + this.state.summary.refundsCnt],
            datasets: [
                {
                    label: 'Sales Count',
                    backgroundColor: ['#1E88E5', '#43A047', '#FB8C00'],
                    data: [this.state.summary.netSaleCnt, this.state.summary.grossSaleCnt, this.state.summary.refundsCnt]
                }
            ]
        };

        const chartOptions = {
            maintainAspectRatio: false,
            aspectRatio: 1,
            plugins: {
                legend: {
                    labels: {
                        color: '#495057'
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: '#495057'
                    },
                    grid: {
                        color: '#ebedef'
                    }
                },
                y: {
                    ticks: {
                        color: '#495057'
                    },
                    grid: {
                        color: '#ebedef'
                    }
                }
            }
        };

        return (
            <div className="sale-report-page__summary">
                <h2 className="sale-report-page__summary-title">Summary</h2>
                <div className="sale-report-page__summary-grid sale-report-page__summary-grid--two">
                    <div className="sale-report-page__chart-card">
                        <div className="chart-container">
                            <Chart type="bar" data={chartSalesData} options={chartOptions} height={"180px"}/>
                        </div>
                    </div>
                    <div className="sale-report-page__chart-card">
                        <div className="chart-container">
                            <Chart type="bar" data={chartSalesCountData} options={chartOptions} height={"180px"}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }


    __handleChangeStartDate = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        this.setState({startDate: value});
        this.search();
    }
    __handleChangeDaysFilter = (e) => {
        const selectedFilter = e.target.value;
        let startDate = null;
        let endDate = null;

        switch (selectedFilter) {
            case 'Today':
                startDate = GeneralUtils.getStartOfToday();
                endDate = GeneralUtils.getEndOfToday();
                break;
            case 'This Week':
                startDate = GeneralUtils.getMonday();
                endDate = GeneralUtils.getEndOfToday();
                break;
            case 'Last Week':
                [startDate, endDate] = GeneralUtils.getLastWeekRange();
                break;
            case 'Last 7 Days':
                [startDate, endDate] = GeneralUtils.getLast7DaysRange();
                break;
            case 'This Month':
                [startDate, endDate] = GeneralUtils.getThisMonthRange();
                break;
            case 'Last Month':
                [startDate, endDate] = GeneralUtils.getLastMonthRange();
                break;
            case 'Custom':
                [startDate, endDate] = GeneralUtils.getLast7DaysRange();
                break;
            default:
                startDate = this.state.startDate ? new Date(this.state.startDate) : null;
                endDate = this.state.endDate ? new Date(this.state.endDate) : null;
                break;
        }

        this.setState({
            daysFilter: selectedFilter,
            startDate: startDate ? startDate.getTime() : null,
            endDate: endDate ? endDate.getTime() : null
        });
        this.search();
    };

    __handleChangeClientAgent = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        this.setState({clientAgent: value});
        this.search();
    }

    __handleChangeEndDate = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        this.setState({endDate: value});
        this.search();
    }

    renderSummary() {
        if (this.refDataTable != undefined) {


            return (<div><Row>
                    <Col md={2}>
                        <h6 style={{fontWeight: "bold"}}>Net
                            Sale:&nbsp;{GeneralUtils.formatGBP(this.state.summary.netSale)}</h6>
                    </Col>

                    <Col md={2}>
                        <h6 style={{fontWeight: "bold"}}>Gross
                            Sale:&nbsp;{GeneralUtils.formatGBP(this.state.summary.grossSale)}</h6>
                    </Col>

                    <Col md={2}>
                        <h6 style={{fontWeight: "bold"}}>Refund
                            Sale:&nbsp;{GeneralUtils.formatGBP(this.state.summary.refunds)}</h6>
                    </Col>


                </Row>
                </div>
            )

        }

    }

    closeDisplayDialogFilter = () => {
        this.setState({displayDialogFilter: false});
    }

    onDataSelectFilter = (data) => {
        this.setState({
            merchantBranchId: data.id,
            merchantBranchName: data.tradingName,
            displayDialogFilter: false
        }, () => {
            this.search();
        });


    }

    renderFilter() {
        return (
            <div className="sale-report-page__filter">
                <div className="sale-report-page__filter-row sale-report-page__filter-row--cols-6">
                    <div className="sale-report-page__filter-field sale-report-page__filter-field--picker">
                        <label>Merchant Branch</label>
                        <span className="p-input-icon-right p-input-icon-right--dual">
                            <InputText
                                disabled
                                value={this.state.merchantBranchName || ''}
                                placeholder="Select Merchant Branch"
                                onClick={() => this.setState({displayDialogFilter: true})}/>
                            <i
                                className="pi pi-search"
                                role="button"
                                tabIndex={0}
                                aria-label="Select branch"
                                onClick={() => this.setState({displayDialogFilter: true})}/>
                            <i
                                className="pi pi-times"
                                role="button"
                                tabIndex={0}
                                aria-label="Clear branch"
                                onClick={() => this.setState({merchantBranchId: null, merchantBranchName: ''})}/>
                        </span>
                    </div>

                    <div className="sale-report-page__filter-field">
                        <label htmlFor="admin-sale-report-period">Period</label>
                        <AvField
                            id="admin-sale-report-period"
                            type="select"
                            className="form-control"
                            name="daysFilter"
                            value={this.state.daysFilter}
                            onChange={this.__handleChangeDaysFilter}>
                            {DAYS_FILTER.map(element => (
                                <option value={element.value} key={element.value}>
                                    {element.name}
                                </option>))}
                        </AvField>
                    </div>

                    <div className="sale-report-page__filter-field">
                        <label>Start Date</label>
                        <DateInput
                            name="startDate"
                            format={"DD/MM/YYYY"}
                            placeholder={"Start Date"}
                            onChange={this.__handleChangeStartDate}
                            disabled={this.state.daysFilter !== 'Custom'}
                            value={this.state.startDate}/>
                    </div>

                    <div className="sale-report-page__filter-field">
                        <label>End Date</label>
                        <DateInput
                            name="endDate"
                            format={"DD/MM/YYYY"}
                            placeholder={"End Date"}
                            onChange={this.__handleChangeEndDate}
                            disabled={this.state.daysFilter !== 'Custom'}
                            value={this.state.endDate}/>
                    </div>

                    <div className="sale-report-page__filter-actions">
                        <Button
                            color="outline-primary"
                            className="settings-page__btn--save"
                            onClick={() => this.search()}>
                            <Translate contentKey="entity.action.add">Search</Translate>
                        </Button>
                    </div>
                </div>

                <Dialog
                    visible={this.state.displayDialogFilter}
                    header={"Merchant Branch"}
                    onHide={() => this.setState({displayDialogFilter: false})}
                    style={GeneralUtils.getDialogStyleForMerchantBranchFilter()}>
                    <MerchantBranchFilter
                        ref={(elem) => this.refModelCredentialsSave = elem}
                        onDataSelect={this.onDataSelectFilter}
                        closeDisplayDialog={this.closeDisplayDialogFilter}/>
                </Dialog>
            </div>
        );
    }

    search() {
        this.refDataTable.refresh();
        this.refreshSummary();
    }

    refreshSummary() {
        let merchantBranchId = -1;
        if (!GeneralUtils.isNullOrEmpty(this.state.merchantBranchId)) {
            merchantBranchId = this.state.merchantBranchId;
        }

        let startDate = -1;
        if (!GeneralUtils.isNullOrEmpty(this.state.startDate)) {
            startDate = this.state.startDate;
        }
        let endDate = -1;
        if (!GeneralUtils.isNullOrEmpty(this.state.endDate)) {
            endDate = this.state.endDate;
        }

        let clientAgent = "-1";
        if (!GeneralUtils.isNullOrEmpty(this.state.clientAgent)) {
            clientAgent = this.state.clientAgent;
        }

        this.adminZXReportService.getSummary(merchantBranchId, startDate, endDate, clientAgent).then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                this.setState({summary: response});
            }

        });

    }


    renderReports() {
        let merchantBranchId = -1;
        if (!GeneralUtils.isNullOrEmpty(this.state.merchantBranchId)) {
            merchantBranchId = this.state.merchantBranchId;
        }
        let startDate = -1;
        if (!GeneralUtils.isNullOrEmpty(this.state.startDate)) {
            startDate = this.state.startDate;
        }
        let endDate = -1;
        if (!GeneralUtils.isNullOrEmpty(this.state.endDate)) {
            endDate = this.state.endDate;
        }

        let clientAgent = "-1";
        if (!GeneralUtils.isNullOrEmpty(this.state.clientAgent)) {
            clientAgent = this.state.clientAgent;
        }

        return (
            <div>
                <div className="sale-report-page__table-wrap sale-report-page__table-wrap--reports">
                    <DataTable
                        fields={AdminSaleReportColumn.fields}
                        ref={(elem) => this.refDataTable = elem}
                        objectName={AdminSaleReportColumn.name}
                        onDataSelect={this.onDataSelect}
                        rows={10}
                        reportName="Sale Reports"
                        paginator={true}
                        dataURL={"reporting/admin/zxreport/merchantBranchId/" + merchantBranchId + "/" + startDate + "/" + endDate + "/" + clientAgent}
                        selectionMode="single"
                        loading={this.state.loading}/>
                </div>

                <Dialog visible={this.state.displayDialog}
                    header={"Sale Report Details"}
                    onHide={() => this.setState({displayDialog: false})}
                    style={GeneralUtils.getDialogStyleForReportDialogDetail()}>

                <AdminSaleReportDetail closeDisplayDialog={this.closeDisplayDialog}
                                       ref={(elem) => this.refModelSave = elem}
                />
            </Dialog>


            </div>
        );
    }

    onDataSelect = (data) => {
        GeneralUtils.openDialogThenRef(this, {displayDialog: true}, () => this.refModelSave, (ref) => {
            ref.setData(Object.assign({}, data));
        });
    }

    closeDisplayDialog = () => {
        this.setState({displayDialog: false});
        this.search();
    }


}

